/* eslint-disable react-hooks/exhaustive-deps */

import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';

import { analyticService } from 'global/services';
import { isSubscription } from 'app/const/subscription';
import { paymentMethodVar, subscriptionInfoPopupTransitionVar, subscriptionTypeVar } from 'app/apollo/reaction';

import { UIParagraph, UIToggleSwitch } from 'app/components/ui';
import { BasketCheckPrice } from './BasketCheckPrice';

import { locales } from './basket-check.locales';

import './basket-check-rows.scss';
import { useReactiveVar } from '@apollo/client';


const noop = () => { };


const hidingSwitchRenderContexts = [
    'stepByStepCheckout',
    'delivery-basket',
];

export const Subscription = ({
    renderContext = '',
    locale,
    // DATA
    basket: {
        isSubscriptionActivated,
        totals: {
            subscriptionDiscountAmount,
        },
    },
    // subscriptionType,
    // ACTIONS
    onToggleSubscription = noop,
}) => {
    const subscriptionType = useReactiveVar(subscriptionTypeVar);
    const isDelivery = renderContext === 'delivery-basket';

    /* STATE */
    const [lockToggle, setLockToggle] = useState(false);
    const [
        isChecked,
        setIsChecked,
    ] = useState(subscriptionType === 'subscription');

    const [initialMethod] = useState(paymentMethodVar());

    const currentSubscriptionDiscountAmount = useMemo(
        () => ((
            (isDelivery && isSubscriptionActivated)
                || (!isDelivery && isSubscription(subscriptionType))
        ) ? subscriptionDiscountAmount : 0),
        [subscriptionType, subscriptionDiscountAmount],
    );

    useEffect(() => {
        setIsChecked(isSubscription(subscriptionType));
    }, [subscriptionType]);

    const toggleSubscriptionType = useCallback((event) => {
        if (!lockToggle) {
            const nextType = event.target.checked ? 'subscription' : 'singlePay';
            const nextMethod = event.target.checked ? 'recurrent' : initialMethod;

            setLockToggle(true);
            event.stopPropagation();
            setIsChecked(event.target.checked);
            onToggleSubscription(nextType, nextMethod);
            setTimeout(() => { setLockToggle(false); }, 800);
        }
    }, [lockToggle]);

    const l = locales[locale];

    const openSubsriptionInfoHadler = useCallback(() => {
        analyticService.push({ eventName: 'Check_Info_About_Subscription' });
        subscriptionInfoPopupTransitionVar('entered');
    }, []);

    return (
        <div styleName="basket-check__row">
            <div
                styleName="basket-check-sub-wrapper"
                key="check-row-1"
            >
                {!hidingSwitchRenderContexts.includes(renderContext) && (
                    <div styleName="basket-check-sub__toggle">
                        <UIToggleSwitch
                            onChanegHandler={toggleSubscriptionType}
                            isChecked={isChecked}
                        />
                    </div>
                )}
                <button
                    onClick={openSubsriptionInfoHadler}
                    type="button"
                >
                    <UIParagraph level="4.2" styleName="basket-check__row-text">
                        <span styleName="text-0">
                            <span styleName="link">
                                {l.subscriptionSmall}
                            </span>
                        </span>
                        <span styleName="text-375">
                            {l.subscriptionBigPref}
                            &nbsp;
                            <span styleName="link">
                                {l.subscriptionBigLink}
                            </span>
                        </span>
                    </UIParagraph>
                </button>
            </div>
            <div
                key="check-row-2"
            >
                <BasketCheckPrice price={currentSubscriptionDiscountAmount} sign="-" />
            </div>
        </div>
    );
};

Subscription.propTypes = {
    renderContext: PropTypes.string,
    basket: PropTypes.shape({
        totals: PropTypes.shape({
            total_price: PropTypes.number.isRequired,
            delivery_price: PropTypes.number.isRequired,
            referral_amount: PropTypes.number.isRequired,
            total_common_price: PropTypes.number.isRequired,
            discount_amount: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    locale: PropTypes.string.isRequired,
    subscriptionType: PropTypes.string.isRequired,
    onToggleSubscription: PropTypes.func,
};
